import http from "./Http";

export default {
    getOrcamentoConsultaPivotGrid: function (data) {
        return http.post('./api/orcamento/consultar/pivotgrid', data)
    },
    getOrcamentoConsultaPlano: function (origem, handleOrcamento) {
        return http.get("./api/financeiro/gerenciais/codigoPlano/" + origem + "/" + handleOrcamento)
    },
    getSituacaoEmpresaMestre: function() {
        return http.get("./api/financeiro/gerenciais/situacaoEmpresaMestre");
        //return http.get("./api/orcamento/consultar/situacaoEmpresaMestre");
    },
    getAcaoProjetoEhVisivel: function(){
        return http.get("./api/orcamento/consultar/acaoProjetoEhVisivel");
    },
    ehOrcamentoPublico: function () {
        return http.get("./api/financeiro/gerenciais/ehOrcamentoPublico");
    },
    postPerfilOrcamento: function (data) {
        return http.post('./api/orcamento/consultar/postPerfilOrcamento', data)
    },
    deletePerfilOrcamento: function (handle) {
        return http.post('./api/orcamento/consultar/deletePerfilOrcamento/' + handle)
    },
    getPerfilOrcamento: function (handle) {
        return http.get('./api/orcamento/consultar/getPerfilOrcamento/' + handle)
    },
    getDescricoesLookup: function (entityName, handles) {
        return http.post('./api/orcamento/consultar/descricoesLookup', { entityName: entityName, handles: handles })
    },
    getComposicaoFuncionalProgramatica: function (handle) {
        return http.get('./api/orcamento/consultar/composicaoFuncionalProgramatica/' + handle)
    },
    getComposicaoNaturezaDespesa: function (handle) {
        return http.get('./api/orcamento/consultar/composicaoNaturezaDespesa/' + handle)
    },
    getCamposExtras: function () {
        return http.get('./api/orcamento/consultar/camposExtras')
    }
}